import styled, { css } from "styled-components"
import SearchResult from "./search-result"

const Popover = css`
  max-height: 80vh;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  z-index: 2;
  right: 0;
  top: 100%;
  margin: 1.5em auto 0;
  width: 80vw;
  max-width: 28em;
  box-shadow: 0 0 5px 0;
  padding: 1em;
  border-radius: 2px;
  background: ${({ theme }) => theme.background};
`

export default styled(SearchResult)`
  display: ${props => (props.show ? `block` : `none`)};
  ${Popover}
  z-index:2000;
  .HitCount {
    display: flex;
    justify-content: flex-end;
  }

  .Hits {
    ul {
      list-style: none;
      margin-left: 0;
    }

    li.ais-Hits-item {
      margin-bottom: 1.6em 0;
      border-bottom:1px solid black;
      div{
        padding:5px 0;
        margin:5px 0;
        border-bottom:1px solid rgba($color: #000000, $alpha: 0.4);
      }

      a {
        color: ${({ theme }) => theme.foreground};

        h4 {
          margin-bottom: .6em;
        }
      }
    }
  }

  .ais-PoweredBy {
    display: none;
  }
`